"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AlgebraVisualization_1 = __importDefault(require("../visualizations/algebra/AlgebraVisualization"));
const GeometryVisualization_1 = __importDefault(require("../visualizations/geometry/GeometryVisualization"));
const CalculusVisualization_1 = __importDefault(require("../visualizations/calculus/CalculusVisualization"));
const FourierSeriesVisualization_1 = __importDefault(require("../visualizations/calculus/FourierSeriesVisualization"));
const FractalGeometryVisualization_1 = __importDefault(require("../visualizations/fractals/FractalGeometryVisualization"));
const RiemannSumsVisualization_1 = __importDefault(require("../visualizations/calculus/RiemannSumsVisualization"));
const VectorFieldVisualization_1 = __importDefault(require("../visualizations/calculus/VectorFieldVisualization"));
const ConicSectionsVisualization_1 = __importDefault(require("../visualizations/ConicSectionsVisualization"));
const ComplexMappingVisualization_1 = __importDefault(require("../visualizations/complex/ComplexMappingVisualization"));
const ProbabilityVisualization_1 = __importDefault(require("../visualizations/statistics/ProbabilityVisualization"));
const Visualization = ({ type }) => {
    switch (type) {
        case 'algebra':
            return react_1.default.createElement(AlgebraVisualization_1.default, null);
        case 'geometry':
            return react_1.default.createElement(GeometryVisualization_1.default, null);
        case 'calculus':
            return react_1.default.createElement(CalculusVisualization_1.default, null);
        case 'fourier':
            return react_1.default.createElement(FourierSeriesVisualization_1.default, null);
        case 'fractals':
            return react_1.default.createElement(FractalGeometryVisualization_1.default, null);
        case 'riemann':
            return react_1.default.createElement(RiemannSumsVisualization_1.default, null);
        case 'vectorfields':
            return react_1.default.createElement(VectorFieldVisualization_1.default, null);
        case 'conic-sections':
            return react_1.default.createElement(ConicSectionsVisualization_1.default, null);
        case 'complex-mapping':
            return react_1.default.createElement(ComplexMappingVisualization_1.default, null);
        case 'probability':
            return react_1.default.createElement(ProbabilityVisualization_1.default, null);
        default:
            return react_1.default.createElement("div", null, "Select a visualization type.");
    }
};
exports.default = Visualization;
